<lib-tacho-message-section [tacho]="tacho"></lib-tacho-message-section>
<div *ngIf="hasAllNeededDrivingInfo()"
  class="tacho-balloon-driving-info">

  <div class="tacho-balloon-driving-info-row">
    <span i18n="@@S_TACHO_BALLOON_DRIVE_TIME_REMAINING">Drive Time Remaining:</span>
    <div *ngIf="this.initialTacho?.DriverWorkingTime?.DriveTimeRemainingToday >= 0"
      class="tacho-balloon-driving-info-horizontal-element">
      {{ getHoursStringFromSeconds(this.initialTacho?.DriverWorkingTime?.DriveTimeRemainingToday) }}<span i18n="@@S_TACHO_BALLOON_HOUR_SHORT">h</span>
      {{ getMinutesStringFromSeconds(this.initialTacho?.DriverWorkingTime?.DriveTimeRemainingToday) }}<span i18n="@@S_TACHO_BALLOON_MINUTE_SHORT">m</span>
      <span class="tacho-balloon-driving-info-horizontal-element"
        i18n="@@S_TACHO_BALLOON_DAY_SHORT">(D)</span>
    </div>
    <div *ngIf="this.initialTacho?.DriverWorkingTime?.DriveTimeRemainingToday < 0"
      class="tacho-balloon-driving-info-horizontal-element tacho-balloon-driving-info-alert">
      <span [fmTooltip]="this.driveTimeRemainingToday_tooltip">
        {{ getHoursStringFromSeconds(this.initialTacho?.DriverWorkingTime?.DriveTimeRemainingToday) }}<span i18n="@@S_TACHO_BALLOON_HOUR_SHORT">h</span>
        {{ getMinutesStringFromSeconds(this.initialTacho?.DriverWorkingTime?.DriveTimeRemainingToday) }}<span i18n="@@S_TACHO_BALLOON_MINUTE_SHORT">m</span>
        <span class="tacho-balloon-driving-info-horizontal-element"
          i18n="@@S_TACHO_BALLOON_DAY_SHORT">(D)</span>
      </span>
    </div>

    <span class="tacho-balloon-driving-info-horizontal-element">/</span>

    <div *ngIf="this.initialTacho?.DriverWorkingTime?.DriveTimeRemainingWeek >= 0"
      class="tacho-balloon-driving-info-horizontal-element">
      {{ getHoursStringFromSeconds(this.initialTacho?.DriverWorkingTime?.DriveTimeRemainingWeek) }}<span i18n="@@S_TACHO_BALLOON_HOUR_SHORT">h</span>
      {{ getMinutesStringFromSeconds(this.initialTacho?.DriverWorkingTime?.DriveTimeRemainingWeek) }}<span i18n="@@S_TACHO_BALLOON_MINUTE_SHORT">m</span>
      <span class="tacho-balloon-driving-info-horizontal-element"
        i18n="@@S_TACHO_BALLOON_WEEK_SHORT">(W)</span>
    </div>
    <div *ngIf="this.initialTacho?.DriverWorkingTime?.DriveTimeRemainingWeek < 0"
      class="tacho-balloon-driving-info-horizontal-element tacho-balloon-driving-info-alert">
      <span [fmTooltip]="this.driveTimeRemainingWeek_tooltip">
        {{ getHoursStringFromSeconds(this.initialTacho?.DriverWorkingTime?.DriveTimeRemainingWeek) }}<span i18n="@@S_TACHO_BALLOON_HOUR_SHORT">h</span>
        {{ getMinutesStringFromSeconds(this.initialTacho?.DriverWorkingTime?.DriveTimeRemainingWeek) }}<span i18n="@@S_TACHO_BALLOON_MINUTE_SHORT">m</span>
        <span class="tacho-balloon-driving-info-horizontal-element"
          i18n="@@S_TACHO_BALLOON_WEEK_SHORT">(W)</span>
      </span>
    </div>
  </div>

  <div class="tacho-balloon-driving-info-row">
    <span i18n="@@S_TACHO_BALLOON_ON_DUTY_REMAINING">On Duty Remaining:</span>
    <div *ngIf="this.initialTacho?.DriverWorkingTime?.OnDutyRemainingToday >= 0"
      class="tacho-balloon-driving-info-horizontal-element">
      {{ getHoursStringFromSeconds(this.initialTacho?.DriverWorkingTime?.OnDutyRemainingToday) }}<span i18n="@@S_TACHO_BALLOON_HOUR_SHORT">h</span>
      {{ getMinutesStringFromSeconds(this.initialTacho?.DriverWorkingTime?.OnDutyRemainingToday) }}<span i18n="@@S_TACHO_BALLOON_MINUTE_SHORT">m</span>
      <span class="tacho-balloon-driving-info-horizontal-element"
        i18n="@@S_TACHO_BALLOON_DAY_SHORT">(D)</span>
    </div>
    <div *ngIf="this.initialTacho?.DriverWorkingTime?.OnDutyRemainingToday < 0"
      class="tacho-balloon-driving-info-horizontal-element tacho-balloon-driving-info-alert">
      <span [fmTooltip]="this.onDutyRemainingToday_tooltip">
        {{ getHoursStringFromSeconds(this.initialTacho?.DriverWorkingTime?.OnDutyRemainingToday) }}<span i18n="@@S_TACHO_BALLOON_HOUR_SHORT">h</span>
        {{ getMinutesStringFromSeconds(this.initialTacho?.DriverWorkingTime?.OnDutyRemainingToday) }}<span i18n="@@S_TACHO_BALLOON_MINUTE_SHORT">m</span>
        <span class="tacho-balloon-driving-info-horizontal-element"
          i18n="@@S_TACHO_BALLOON_DAY_SHORT">(D)</span>
      </span>
    </div>

    <span class="tacho-balloon-driving-info-horizontal-element">/</span>

    <div *ngIf="this.initialTacho?.DriverWorkingTime?.OnDutyRemainingWeek >= 0"
      class="tacho-balloon-driving-info-horizontal-element">
      {{ getHoursStringFromSeconds(this.initialTacho?.DriverWorkingTime?.OnDutyRemainingWeek) }}<span i18n="@@S_TACHO_BALLOON_HOUR_SHORT">h</span>
      {{ getMinutesStringFromSeconds(this.initialTacho?.DriverWorkingTime?.OnDutyRemainingWeek) }}<span i18n="@@S_TACHO_BALLOON_MINUTE_SHORT">m</span>
      <span class="tacho-balloon-driving-info-horizontal-element"
        i18n="@@S_TACHO_BALLOON_WEEK_SHORT">(W)</span>
    </div>
    <div *ngIf="this.initialTacho?.DriverWorkingTime?.OnDutyRemainingWeek < 0"
      class="tacho-balloon-driving-info-horizontal-element tacho-balloon-driving-info-alert">
      <span [fmTooltip]="this.onDutyRemainingWeek_tooltip">
        {{ getHoursStringFromSeconds(this.initialTacho?.DriverWorkingTime?.OnDutyRemainingWeek) }}<span i18n="@@S_TACHO_BALLOON_HOUR_SHORT">h</span>
        {{ getMinutesStringFromSeconds(this.initialTacho?.DriverWorkingTime?.OnDutyRemainingWeek) }}<span i18n="@@S_TACHO_BALLOON_MINUTE_SHORT">m</span>
        <span class="tacho-balloon-driving-info-horizontal-element"
          i18n="@@S_TACHO_BALLOON_WEEK_SHORT">(W)</span>
      </span>
    </div>
  </div>

  <div *ngIf="hasNextBreakDue"
    class="tacho-balloon-driving-info-row">
    <span i18n="@@S_TACHO_BALLOON_NEXT_BREAK_DUE">Next Break Due:</span>
    <div *ngIf="this.initialTacho?.DriverWorkingTime?.NextBreakDue >= 0"
      class="tacho-balloon-driving-info-horizontal-element">
      {{ getHoursStringFromSeconds(this.initialTacho?.DriverWorkingTime?.NextBreakDue) }}<span i18n="@@S_TACHO_BALLOON_HOUR_SHORT">h</span>
      {{ getMinutesStringFromSeconds(this.initialTacho?.DriverWorkingTime?.NextBreakDue) }}<span i18n="@@S_TACHO_BALLOON_MINUTE_SHORT">m</span>
    </div>
    <div *ngIf="this.initialTacho?.DriverWorkingTime?.NextBreakDue < 0"
      class="tacho-balloon-driving-info-horizontal-element tacho-balloon-driving-info-alert">
      <span [fmTooltip]="this.nextBreakDue_tooltip">
        {{ getHoursStringFromSeconds(this.initialTacho?.DriverWorkingTime?.NextBreakDue) }}<span i18n="@@S_TACHO_BALLOON_HOUR_SHORT">h</span>
        {{ getMinutesStringFromSeconds(this.initialTacho?.DriverWorkingTime?.NextBreakDue) }}<span i18n="@@S_TACHO_BALLOON_MINUTE_SHORT">m</span>
      </span>
    </div>
  </div>
  <div *ngIf="!hasNextBreakDue"
    class="tacho-balloon-driving-info-row">
    <span i18n="@@S_TACHO_BALLOON_NEXT_BREAK_DUE">Next Break Due:</span>
    <div class="tacho-balloon-driving-info-horizontal-element">
      <span class="tacho-balloon-driving-info-horizontal-element"
        i18n="@@S_TACHO_BALLOON_NOT_AVAILABLE_SHORT">N/A</span>
    </div>
  </div>

  <div class="tacho-balloon-driving-info-row">
    <span i18n="@@S_TACHO_BALLOON_10H_DRIVE_EXTENSION">10h Drive Extension:</span>
    <div *ngIf="this.initialTacho?.DriverWorkingTime?.ExtendedDrivesRemaining >= 0"
      class="tacho-balloon-driving-info-horizontal-element">
      {{ this.initialTacho?.DriverWorkingTime?.ExtendedDrivesRemaining }}
    </div>
    <div *ngIf="this.initialTacho?.DriverWorkingTime?.ExtendedDrivesRemaining < 0"
      class="tacho-balloon-driving-info-horizontal-element tacho-balloon-driving-info-alert">
      <span [fmTooltip]="this.extendedDrivesRemaining_tooltip">
        {{ this.initialTacho?.DriverWorkingTime?.ExtendedDrivesRemaining }}
      </span>
    </div>
  </div>

  <div class="tacho-balloon-driving-info-row">
    <span i18n="@@S_TACHO_BALLOON_9H_REST_REDUCTION">9h Rest Reduction:</span>
    <div *ngIf="this.initialTacho?.DriverWorkingTime?.ReducedRestRemaining >= 0"
      class="tacho-balloon-driving-info-horizontal-element">
      {{ this.initialTacho?.DriverWorkingTime?.ReducedRestRemaining }}
    </div>
    <div *ngIf="this.initialTacho?.DriverWorkingTime?.ReducedRestRemaining < 0"
      class="tacho-balloon-driving-info-horizontal-element tacho-balloon-driving-info-alert">
      <span [fmTooltip]="this.reducedRestRemaining_tooltip">
        {{ this.initialTacho?.DriverWorkingTime?.ReducedRestRemaining }}
      </span>
    </div>
  </div>

</div>
